import React from 'react';

/* ─── Baby foot icon for logo circles ──────────────────────────
   Vertical ellipse = human foot shape (NOT animal paw).
   Big toe is on the inner side, pinky on the outer side.        */
export const BabyFootIcon = ({ size = 28, color = 'white' }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Left footprint — lower-left, big toe on RIGHT (inner side of left foot) */}
    <g transform="translate(11,27) rotate(-16)">
      {/* Vertical oval = human foot, NOT horizontal paw */}
      <ellipse cx="0" cy="2" rx="4" ry="7" fill={color} opacity="0.90"/>
      <circle cx="3.5"  cy="-6.2" r="1.9" fill={color}/>  {/* big toe (inner) */}
      <circle cx="1.5"  cy="-7.8" r="1.6" fill={color}/>
      <circle cx="-0.5" cy="-8.3" r="1.4" fill={color}/>
      <circle cx="-2.5" cy="-7.6" r="1.2" fill={color}/>
      <circle cx="-4"   cy="-6.2" r="1.0" fill={color}/>  {/* pinky (outer) */}
    </g>
    {/* Right footprint — upper-right, big toe on LEFT (inner side of right foot) */}
    <g transform="translate(29,13) rotate(16)">
      <ellipse cx="0" cy="2" rx="4" ry="7" fill={color} opacity="0.90"/>
      <circle cx="-3.5" cy="-6.2" r="1.9" fill={color}/>  {/* big toe (inner) */}
      <circle cx="-1.5" cy="-7.8" r="1.6" fill={color}/>
      <circle cx="0.5"  cy="-8.3" r="1.4" fill={color}/>
      <circle cx="2.5"  cy="-7.6" r="1.2" fill={color}/>
      <circle cx="4"    cy="-6.2" r="1.0" fill={color}/>  {/* pinky (outer) */}
    </g>
  </svg>
);

/* ─── Shared logo box — uses the actual favicon.svg asset ────────
   Single source of truth — import TinyStepsLogo everywhere.      */
export const TinyStepsLogo = ({ size = 58 }) => (
  <img
    src="/tinysteps-logo1.png"
    alt="TinySteps"
    style={{
      width: size,
      height: size,
      borderRadius: Math.round(size * 0.28),
      boxShadow: '0 4px 18px rgba(246,141,179,0.45)',
      flexShrink: 0,
      display: 'block',
    }}
  />
);

